// extracted by mini-css-extract-plugin
export default {"section":"styles_section__sCYVn"};